"use client";

import { APP_ROUTES } from "@/constants/routes";
import Link from "next/link";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 py-6">
      <div className="text-center max-w-md mx-auto animate-fadeIn">
        {/* 404 Number */}
        <div
          className="text-8xl sm:text-9xl font-black mb-6 drop-shadow-lg animate-bounce"
          style={{ color: "#1F61A9" }}
        >
          404
        </div>

        {/* Title */}
        <h1
          className="text-4xl sm:text-5xl font-bold mb-4 drop-shadow-md"
          style={{ color: "#1F61A9" }}
        >
          Page Not Found
        </h1>

        {/* Description */}
        <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed drop-shadow-sm">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>

        {/* Decorative Line */}
        <div className="flex justify-center mb-8">
          <div
            className="w-16 h-1 rounded-full"
            style={{ backgroundColor: "#a6cc17" }}
          ></div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link href={APP_ROUTES().HOME.to} className="w-full sm:w-auto">
            <button
              className="w-full px-8 py-3 text-white font-bold text-lg rounded-lg shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              style={{ backgroundColor: "#1F61A9" }}
            >
              Go Home
            </button>
          </Link>
          <button
            onClick={() => window.history.back()}
            className="w-full sm:w-auto px-8 py-3 border-2 font-bold text-lg rounded-lg hover:-translate-y-1 transition-all duration-300"
            style={{ borderColor: "#1F61A9", color: "#1F61A9" }}
          >
            Go Back
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.6s ease-in;
        }

        .animate-bounce {
          animation: bounce 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default NotFound;
